export default __webpack_public_path__ + "img/MidwayMkt-logoOnly.png";